import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import {computed} from "vue";
import Icon from "../Icon/Icon.vue";
import {IconName} from "../Icon/icons";
import Material, {MaterialRound} from "./Material.vue";

interface Props {
  nested?: boolean;
  icon?: IconName;
  testId?: string;
  nestedPill?: boolean;
  space?: boolean;
  bigSpace?: boolean;
  desktopSpace?: boolean;
  vertical?: boolean;
  text?: string;
  shadow?: boolean;
  href?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Tile',
  props: {
    nested: { type: Boolean },
    icon: {},
    testId: {},
    nestedPill: { type: Boolean },
    space: { type: Boolean },
    bigSpace: { type: Boolean },
    desktopSpace: { type: Boolean },
    vertical: { type: Boolean },
    text: {},
    shadow: { type: Boolean },
    href: {}
  },
  setup(__props: any) {

const props = __props;

const tileClass = computed(() => [padding(), verticalSpacing(), fontSize(), wrapping(), shadow(), cursor()]);

const rounded = computed((): MaterialRound => {
  if (props.nestedPill) {
    return 'full';
  }
  if (props.nested) {
    return 'regular';
  }
  return 'large';
});

function padding(): string {
  if (props.nestedPill) {
    return 'py-2 px-3';
  }
  if (props.desktopSpace) {
    return 'p-2 md:p-4';
  }
  if (props.bigSpace) {
    return 'p-4 md:p-6';
  }
  if (props.space) {
    return 'p-4';
  }
  return 'p-2';
}

function verticalSpacing(): string {
  if (props.vertical) {
    if (props.bigSpace) {
      return 'space-y-6';
    }
    return props.space ? 'space-y-4' : 'space-y-2';
  }
  return '';
}

function fontSize(): string {
  return props.nestedPill ? 'text-sm' : '';
}

function wrapping(): string {
  return props.nestedPill ? 'whitespace-nowrap' : '';
}

function shadow(): string {
  return props.shadow ? 'shadow-2xl' : '';
}

function cursor(): string {
  return props.clickable ? 'cursor-pointer' : '';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Material, {
    nested: props.nested || props.nestedPill,
    round: rounded.value,
    class: _normalizeClass(tileClass.value),
    href: props.href,
    "data-testid": props.testId
  }, {
    default: _withCtx(() => [
      (props.icon)
        ? (_openBlock(), _createBlock(Icon, {
            key: 0,
            name: props.icon,
            class: "mr-2"
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(props.text) + " ", 1 /* TEXT */),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["nested", "round", "class", "href", "data-testid"]))
}
}

})